import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Icons, IconButton, MenuItem, Menu, ListItemText } from "@curves/ui-base";
import { giftDispatchByMemberList } from "@icoach/members/staticData";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants";
import { isEqual } from "@util/utils";

/**
 * 快速名單使用共用元件
 */
export const QuickMoreLabelBox = props => {
	const { rowData, dialogRef, targetType, onKeepState } = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const history = useHistory();
	const open = Boolean(anchorEl);

	const handleToggleClick = e => {
		setAnchorEl(e.currentTarget);
	};
	// 關閉menu錨點
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<React.Fragment>
			<IconButton onClick={handleToggleClick}>
				<Icons.MoreVertical />
			</IconButton>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				<MenuItem
					onClick={() => {
						onKeepState && onKeepState(rowData);
						handleClose();
						history.push(CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(rowData.memberID, MEMBERS_MEMBER_DETAIL_TABS.WORKOUT));
					}}
				>
					<ListItemText>查看</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						dialogRef.current.openContactDialog(rowData);
						handleClose();
					}}
				>
					<ListItemText>新增聯繫</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						dialogRef.current.openSmsDialog([{ id: rowData.id, type: rowData.type, name: rowData.nickName || rowData.name || rowData.memberName }]);
						handleClose();
					}}
				>
					<ListItemText>發送簡訊</ListItemText>
				</MenuItem>
				{giftDispatchByMemberList.some(x => isEqual(x, targetType)) && (
					<MenuItem
						onClick={() => {
							dialogRef.current.openGiftDispatchDialog({ memberIDs: [rowData.id] });
							handleClose();
						}}
					>
						<ListItemText>贈品發送</ListItemText>
					</MenuItem>
				)}
			</Menu>
		</React.Fragment>
	);
};

export default QuickMoreLabelBox;
